import * as angular from 'angular';

/**
 * This directive will display an overlayed message within its container
 * @example: <div apt-empty-content-overlay-message
 *                is-message-visible="$ctrl.isEmptyMessageVisible"
 *                message="$ctrl.noContentMessage">
 *            </div>
 */

export class AptEmptyContentOverlayMessageController {
  isMessageVisible: boolean;
  message: string;

  constructor(private $element) {
    'ngInject';
  }

  $onChanges() {
    if (this.isMessageVisible && this.message) {
      angular
        .element(this.$element)
        .attr('data-empty-content-overlay-message', this.message);
    } else if (!this.isMessageVisible || !this.message) {
      angular
        .element(this.$element)
        .removeAttr('data-empty-content-overlay-message');
    }
  }
}

export function AptEmptyContentOverlayMessageDirective() {
  return {
    restrict: 'A',
    bindToController: {
      isMessageVisible: '<',
      message: '<'
    },
    scope: {},
    controllerAs: '$ctrl',
    controller: AptEmptyContentOverlayMessageController
  };
}
